import { Modal, Button } from 'flowbite-react';
import React from 'react';
import { useToast } from 'src/context/ToastProvider';
import { useMutation, useQueryClient } from 'react-query';
import { deleteAccount } from 'src/apis/user';
import { signout } from 'src/apis/auth';
import { STUDENT_APP_ENDPOINT } from 'src/config/env.config';
import { RxCross2 } from 'react-icons/rx';
import { useLayoutContext } from 'src/context/LayoutProvider';
const DeleteUserAccountModal = () => {
	const toast = useToast();
	const { isDeleteUserModalOpen, onDeleteUserModalClose } = useLayoutContext();
	const signoutFn = useMutation(['signout'], signout, {
		onSuccess() {
			window.open(`${STUDENT_APP_ENDPOINT}/auth/signin`, '_self');
		},
	});

	const deleteAccountMutation = useMutation(['deleteAccount'], deleteAccount, {
		onSuccess() {
			toast({
				title: 'Account deleted successfully!',
				type: 'success',
			});
			setIsLoading(false);
			signoutFn.mutate();
		},
		onError(error: Error) {
			setIsLoading(false);
			toast({
				title: `Error occured while deleting user  ${error.message}`,
				type: 'error',
			});
		},
	});

	const [isLoading, setIsLoading] = React.useState(false);
	const [deleteInputValue, setDeleteInputValue] = React.useState('');
	return (
		<div>
			<Modal
				position={'center'}
				dismissible={true}
				size={'md'}
				show={isDeleteUserModalOpen}
				onClose={onDeleteUserModalClose}
			>
				<Modal.Body className="relative flex flex-col gap-y-8 justify-center rounded-[8px] border border-solid border-[#555770] dark:bg-[#1F2A37] p-8">
					<div>
						<h6 className="font-inter text-[20px] font-[600] leading-[120%]">Delete your account</h6>
						<p className="mt-[16px] font-inter text-[16px] font-[400] leading-[24px]">
							Deleting your account will remove all your personal information, purchases and progress from our database.
							This cannot be undone.
						</p>
						<p className="mt-[16px] font-inter text-[16px] font-[400] leading-[24px]">
							To confirm deletion, type “DELETE” below:
						</p>
						<input
							className="mt-[16px] w-[100%] rounded-[8px] dark:bg-[#374151] border border-[#EBEBF0] dark:border-[#4B5563] "
							type="text"
							placeholder={'type DELETE here...'}
							value={deleteInputValue}
							onChange={e => setDeleteInputValue(e.target.value)}
						/>
						<div className="mt-[16px] flex items-center gap-[16px] justify-center">
							<Button
								disabled={isLoading || deleteInputValue.trim().toLowerCase() !== 'delete'}
								color="purplePlaced"
								onClick={() => {
									setIsLoading(true);
									deleteAccountMutation.mutate();
								}}
							>
								Confirm Deletion
							</Button>
							<Button color="light" onClick={onDeleteUserModalClose}>
								No, Cancel
							</Button>
						</div>
					</div>
					<RxCross2
						onClick={onDeleteUserModalClose}
						className="absolute right-[10px] top-[10px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
					/>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default DeleteUserAccountModal;
